import script from "./LayoutColumnMixin.vue?vue&type=script&lang=js"
export * from "./LayoutColumnMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__